<template>
    <div class="pane">
        <div>
            <span><Icon type="logo-buffer"/></span>
            <span class="pane-text" >{{$t('l.community_list')}}</span>
        </div>
        <div class="pane-div">
            <Select @on-change="change" size="default" :placeholder="$t('l.remark64')" v-model="current_community.id"
                    filterable class="pane-select">
                <Option v-for="item in communitys" :value="item.id" :key="item.id">{{item.name}}</Option>
            </Select>
        </div>
        <div v-if="j_buildings">
            <Tree :data="j_buildings"
                  :empty-text="emptyText"
                  :render="renderTree"
                  @on-toggle-expand="onToggleExpand"
                  ref="refTree">
            </Tree>
        </div>
    </div>
</template>

<script>
    export default {
        name: "community-tree",
        props:{
            communitys:Array,
            j_buildings:Array,
            current_community:Object,
            emptyText:{
                type:String,
                default:'',
                required:false
            }
        },
        data(){
            return{
                activeLable:''
            }
        },
        methods:{
            onToggleExpand(node){
                this.$emit("onToggleExpand",node);
            },
            change(v){
                this.$emit("change",v);
            },
            renderTree(h, {root, node, data}) {
                return h('span', {
                    style: {
                        display: 'inline-block',
                        width: '90%'
                    },
                    class: {
                        'tree-item': true
                    }
                }, [
                    h('span', [
                        h('span', {
                            on: {
                                click: () => {
                                    this.onTreeSelect(root, node, data);
                                }
                            },
                            style: {
                                padding: '1px 5px',
                                borderRadius: '2px'
                            },
                            class: {
                                active: data.lable === this.activeLable,
                                'tree-line': true,
                            },
                        }, data.name)
                    ])
                ]);
            },
            onTreeSelect(root, node, data) { // 选择节点
                let activeLable = this.activeLable === data.lable;
                if (activeLable){
                    this.activeLable = ""
                } else{
                    this.activeLable = data.lable;
                }
                this.$emit("onTreeSelect",root,node,data,activeLable);
            },
        }
    }
</script>

<style scoped lang="less">
.pane{
    width: 100%;
    &-text{
        font-weight: 600;
        margin-left: 10px;
        font-size: 16px;
    }
    &-div{
        margin: 10px 0;
    }
    &-select{
            width: 70%;
    }
}
</style>